import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface LoadingIndicatorProps {
  loadingText?: string;
  sizeOfIndicator?: string;
  sizeOfText?: string;
  color?: string;
  overlayLoader?: boolean;
  showLoadingText?: boolean;
  sx?: any;
}

const LoadingIndicator = ({
  loadingText,
  sizeOfIndicator,
  sizeOfText,
  color,
  overlayLoader,
  showLoadingText = true,
  sx,
}: LoadingIndicatorProps) => {
  const { t, ready } = useTranslation("common", { useSuspense: false });

  if (!ready) {
    return <></>;
  }

  const translatedLoadingText = loadingText
    ? t(loadingText)
    : t("loadingIndicator.defaultText");

  const loaderSx = {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  };

  const overlaySx = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    background: "rgba(255, 255, 255, 0.6)",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    zIndex: "9999",
  };

  return (
    <>
      <Box
        sx={overlayLoader ? overlaySx : loaderSx}
        data-testid="loading-indicator"
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress
            sx={{
              ...(sx || {}),
              ...(color ? { color } : {}),
            }}
            data-testid="circular-loader"
            size={sizeOfIndicator === undefined ? "2rem" : sizeOfIndicator}
          />
        </Box>
        {showLoadingText && (
          <Typography
            sx={{
              textAlign: "center",
              paddingTop: "1rem",
              fontSize: sizeOfText || "1rem",
            }}
            component="p"
          >
            {`${translatedLoadingText}...`}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default LoadingIndicator;
